import { Component } from '@angular/core';

import { GlobalCommunication } from './global-communication.service';

@Component({
  selector: 'ngx-app',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  constructor(public communication: GlobalCommunication) {}
}
